import { Alert, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { closeSnackbar } from 'store/reducers/snackbarSlice';
import { RootState } from 'store/store';

export const GlobalSnackbar = () => {
    const dispatch = useDispatch();
    const { open, message, severity } = useSelector(
        (state: RootState) => state.snackbar,
    );

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={() => dispatch(closeSnackbar())}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert severity={severity} onClose={() => dispatch(closeSnackbar())}>
                {message}
            </Alert>
        </Snackbar>
    );
};
